const GET_ARTICLES_INIT = "GET_ARTICLES_INIT";
const GET_ARTICLES_SUCCESS = "GET_ARTICLES_SUCCESS";
const GET_ARTICLES_ERROR = "GET_ARTICLES_ERROR";

const DELETE_ARTICLES_INIT = "DELETE_ARTICLES_INIT";
const DELETE_ARTICLES_SUCCESS = "DELETE_ARTICLES_SUCCESS";
const DELETE_ARTICLES_ERROR = "DELETE_ARTICLES_ERROR";

const READ_ARTICLES_INIT = "READ_ARTICLES_INIT";
const READ_ARTICLES_SUCCESS = "READ_ARTICLES_SUCCESS";
const READ_ARTICLES_ERROR = "READ_ARTICLES_ERROR";

export {
    GET_ARTICLES_INIT,
    GET_ARTICLES_SUCCESS,
    GET_ARTICLES_ERROR,

    DELETE_ARTICLES_INIT,
    DELETE_ARTICLES_SUCCESS,
    DELETE_ARTICLES_ERROR,

    READ_ARTICLES_INIT,
    READ_ARTICLES_SUCCESS,
    READ_ARTICLES_ERROR
}
